import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateWithTimeAgo',
  standalone: true,
})
export class DateWithTimeAgoPipe implements PipeTransform {

  public transform(value: Date | string | number | null | undefined, showDate = false, ...args: any[]): any {
    const datePipe = new DatePipe('en-US');

    let dateTime: string | null = '';
    try {
      dateTime = datePipe.transform(value, ...args);
    } catch (error) {
      console.error('DatePipe error:', error);
      return "unknown";
    }

    if (value == null) {
      return dateTime;
    }

    const givenDate = new Date(value);
    const currentDate = new Date();
    let diffInMs = currentDate.getTime() - givenDate.getTime();
    let isInThePast = true;
    if (diffInMs < 0) {
      isInThePast = false;
      diffInMs = -diffInMs;
    }

    const seconds = Math.floor(diffInMs / 1000);
    const minutes = Math.floor(seconds / 60);
    const hours = Math.floor(minutes / 60);
    const days = Math.floor(hours / 24);
    const years = Math.floor(days / 365);

    let timeAgo = '';
    if (seconds < 60) {
      timeAgo = isInThePast ? $localize`${seconds} seconds ago` : $localize`in ${seconds} seconds`;
    } else if (minutes < 60) {
      timeAgo = isInThePast ? $localize`${minutes} minutes ago` : $localize`in ${minutes} minutes`;
    } else if (hours < 24) {
      // const remaningMinutes = minutes % 60;
      timeAgo = isInThePast ? $localize`${hours} hours ago` : $localize`in ${hours} hours`;
    } else if (days < 7) {
      // const remainingHours = hours % 24;
      timeAgo = isInThePast ? $localize`${days} days ago` : $localize`in ${days} days`;
    } else if (years < 1) {
      timeAgo = isInThePast ? $localize`${days} days ago` : $localize`in ${days} days`;
    } else {
      // const remainingDays = days % 365;
      timeAgo = isInThePast ? $localize`${years} years ago` : $localize`in ${years} years`;
    }

    if (showDate) {
      return `${dateTime} (${timeAgo})`;
    } else {
      return timeAgo;
    }
  }

}


